"use strict";
/**
* Copyright: Microsoft 2016
*/
Object.defineProperty(exports, "__esModule", { value: true });
var stringWrapper_1 = require("./stringWrapper");
exports.StringWrapper = stringWrapper_1.StringWrapper;
var stringPart_1 = require("./stringPart");
exports.StringPart = stringPart_1.StringPart;
var InternalStringLoader = /** @class */ (function () {
    function InternalStringLoader() {
    }
    InternalStringLoader.prototype.init = function (loader) {
        this.loader = loader;
    };
    InternalStringLoader.prototype.getString = function (key) {
        return this.loader.getString(key);
    };
    InternalStringLoader.prototype.hasString = function (key) {
        return this.loader.hasString(key);
    };
    return InternalStringLoader;
}());
exports.InternalStringLoader = InternalStringLoader;
exports.internalStringLoader = new InternalStringLoader();
var InternalStringReplacer = /** @class */ (function () {
    function InternalStringReplacer() {
    }
    InternalStringReplacer.prototype.init = function (loader) {
        this.loader = loader;
    };
    InternalStringReplacer.prototype.getString = function (key, params) {
        return this.loader.getString(key, params);
    };
    return InternalStringReplacer;
}());
exports.InternalStringReplacer = InternalStringReplacer;
exports.internalStringReplacer = new InternalStringReplacer();
